import { REDUCER_NAME } from "./config";

export const selectors = {
  /**
   * @returns {{path: string, data: any} | null};
   */
  getLatest: (state) => {
    // if in future we store multiple entries, we can modify this to get
    // the latest based on timestamp or other criteria
    const record = Object.entries(state[REDUCER_NAME] || {})[0];
    if (record) {
      return {
        path: record[0],
        data: record[1],
      };
    }
    return null;
  },
};
